// Core
import { 
  Box,
  Button,
  Flex,
  Image,
  Text, 
  Table,
  Thead,
  Tbody,
  Tr,
  Td,
  VStack,
  useColorModeValue
} from '@chakra-ui/react';

// Assets
import placeholderImage from 'assets/img/empty-plan.png';
import particlesImage from 'assets/img/particles.png';
import { ReactComponent as CoffeeIcon } from 'assets/svg/petrol/coffee.svg';
import { ReactComponent as CoinsIcon } from 'assets/svg/petrol/coins.svg';
import { ReactComponent as EXPIcon } from 'assets/svg/petrol/exp.svg';
import { ReactComponent as GiveawayEntriesIcon } from 'assets/svg/petrol/giveaway-entries.svg';
import { ReactComponent as MiniEntriesIcon } from 'assets/svg/petrol/mini-entries.svg';
import { ReactComponent as DiscountIcon } from 'assets/svg/petrol/discount.svg';
import {
  stylePlansTableTdColors,
  stylePlansTableTh
} from 'services/Utils';

// Components
import IconBox from 'components/Icons/IconBox';

const TablePetrolTr = ({ isDark, title, icon, p, index }) => {
  return (
    <Flex gap="6px"
      p="12px" 
      h={ index === 1 ? '64px' : '44px'}
      borderBottom={`1px solid ${isDark ? '#262D47' : '#E3E8F0'}`}
      alignItems="center"
      bg={isDark ? '#0E1633' : '#FFF'}>
      <Box
        p={p}
        w="20px"
        h="20px"
        borderRadius="full"
        bg="linear-gradient(180deg, #2ABDFD 0%, #0497FD 100%)">
        <IconBox color="white">{icon}</IconBox>
      </Box>
      <Text 
        variant="title-md"
        fontSize={{base: '12px', md: '14px', lg: '16px'}}
        lineHeight="20px"
        >{title}</Text>
    </Flex>
  );
};

const TablePetrol = ({ data, isDark, paymentType }) => {
  const borderColor = useColorModeValue('rgb(227, 232, 240)', 'rgb(38, 45, 71)');
  
  return (
    <Box
      overflowX="auto"
      overflowY="hidden"
      w="100%"
      sx={{
        scrollbarWidth: 'none',       // Firefox
        msOverflowStyle: 'none',      // IE/Edge
        '&::-webkit-scrollbar': {
          display: 'none',            // Chrome/Safari
        },
      }}
    >
      <Box 
        minW="934px"
        maxW="1128px"
        w="100%"
        borderRadius="12px" 
        boxShadow="0 1px 3px 0 rgba(0, 0, 0, 0.10)"
        overflow="hidden"
        borderLeft={`1px solid ${borderColor}`}
        borderRight={`1px solid ${borderColor}`}
      >
    <Table className="membership-table">
      <Thead>
        <Tr>
          <Td borderColor={'transparent'} padding="0">
            <Box 
              h="44px" 
              alignItems="center"
              style={stylePlansTableTh(null, isDark)} />
          </Td>
          { data?.map((item, index) => (
            <>
              {item?.paymentType === paymentType && (() => {
                return (
                  <Td borderColor={'transparent'} position="relative" padding="0">
                    <Flex 
                      gap="6px" 
                      justifyContent="center" 
                      p="10px 12px" 
                      h="44px"
                      alignItems="center"
                      style={stylePlansTableTh(item?.type, isDark)}
                      >
                      <Image w="20px" h="20px" src={item?.image ?? placeholderImage} />
                      <Text variant="title-md" fontSize="20px" textTransform="capitalize" color="white">
                        {item?.type === 'fuel' ? 'Petrol Saver' : item?.type}
                      </Text>
                    </Flex>
                  </Td>
                );
              })()}
            </>
          ))} 
        </Tr>
      </Thead>
      <Tbody>
        <Tr>
          <Td padding="0" w={{base: '147px', md: '192px', lg: '228px'}} borderColor={'transparent'} position="relative" h="239px">
            <Box textAlign="center" h="44px" position="absolute" top="0" w="100%">
              <TablePetrolTr index={1} p="2px" isDark={isDark} title={'Fuel discounts'} icon={<DiscountIcon />} />
              <TablePetrolTr index={2} p="2px" isDark={isDark} title={'Coins / 50 L'} icon={<CoinsIcon />} />
              <TablePetrolTr index={3} p="3px" isDark={isDark} title={'Mini Entries / 50 L'} icon={<MiniEntriesIcon />} />
              <TablePetrolTr index={4} p="3px" isDark={isDark} title={'Giveaway Entries'} icon={<GiveawayEntriesIcon />} />
              <TablePetrolTr index={5} p="3px" isDark={isDark} title={'Coffee Reward'} icon={<CoffeeIcon />} />
            </Box>
          </Td>
          { data?.map((item, index) => (
            <>
              {item?.paymentType === paymentType && (() => {
                return (
                  <>
                    <Td padding="0" borderColor={'transparent'} w={{base: '128px', md: '192px', lg: '225px'}} position="relative" h="239px">
                      <Box textAlign="center" h="44px" position="absolute" top="0" w="100%">
                        <Text h="64px" lineHeight="20px" variant="title-md" fontSize={{base: '12px', md: '14px', lg: '16px'}} p="12px" fontStyle="italic" style={stylePlansTableTdColors(item?.type, isDark)}>depend on the station and location</Text>
                        <Text h="44px" lineHeight="20px" variant="title-md" fontSize={{base: '12px', md: '14px', lg: '16px'}} p="12px" fontStyle="italic" style={stylePlansTableTdColors(item?.type, isDark)}>{!item?.coins || item?.coins === 0 ? 'N/A' : item?.coins}</Text>
                        <Text h="44px" lineHeight="20px" variant="title-md" fontSize={{base: '12px', md: '14px', lg: '16px'}} p="12px" fontStyle="italic" style={stylePlansTableTdColors(item?.type, isDark)}>{!item?.entriesMiniDraw || item?.entriesMiniDraw === 0 ? 'N/A' : item?.entriesMiniDraw}</Text>
                        <Text h="44px" lineHeight="20px" variant="title-md" fontSize={{base: '12px', md: '14px', lg: '16px'}} p="12px" fontStyle="italic" style={stylePlansTableTdColors(item?.type, isDark)}>{
                            item?.type === 'fuel' 
                              ? `${item?.entriesLoyalty ?? 0} / 100 L` 
                              : `${item?.entriesLoyalty ?? 0} / 50 L` 
                          }</Text>
                        <Text h="44px" lineHeight="20px" variant="title-md" fontSize={{base: '12px', md: '14px', lg: '16px'}} p="12px" fontStyle="italic" style={stylePlansTableTdColors(item?.type, isDark)}>{!item?.coffee || item?.coffee === 0 ? 'N/A' : `${item?.coffee ?? 0}th Coffee Free`}</Text>
                      </Box>
                    </Td>
                  </>
                );
              })()}
            </>
          ))} 
        </Tr>
      </Tbody>
    </Table>
    </Box>
    </Box>
    );
};

export default TablePetrol;
